import { render } from "./MisClientes.vue?vue&type=template&id=b18e0fc2&scoped=true"
import script from "./MisClientes.vue?vue&type=script&lang=js"
export * from "./MisClientes.vue?vue&type=script&lang=js"

import "./MisClientes.vue?vue&type=style&index=0&id=b18e0fc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b18e0fc2"]])

export default __exports__